// ══════════════════════════════════════════════════════════════════════════════════════════════
//  «AHORA NO» A LA HUELLA O LA CARA DEL NAVEGADOR: 30 DÍAS, POR PERSONA Y NAVEGADOR  (5-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//  El dueño quiere que se ofrezca a quien todavía no lo tiene «una vez, sin agobiar». Quien dice «Ahora no» no vuelve a
//  ver la oferta en ESTE navegador en DIAS_SIN_PREGUNTAR días (la de la app del móvil es su propia marca:
//  services/entradaBiometrica.noPreguntar). Lo leen la oferta de dentro (components/OfertaHuellaOCara, por
//  services/huellaOCara) y la de la pantalla de bloqueo. Sin imports a propósito: una utilidad que cualquiera puede cargar.
//  Solo una preferencia: no abre nada, no guarda nada de la huella.
export const DIAS_SIN_PREGUNTAR = 30
export const CLAVE_POSPUESTA = 'biango_huella_no_preguntar'

const leer = () => {
  try { const m = JSON.parse(localStorage.getItem(CLAVE_POSPUESTA) || '{}'); return (m && typeof m === 'object') ? m : {} }
  catch { return {} }
}

/** ¿Dijo «Ahora no» esta persona en este navegador hace menos de DIAS_SIN_PREGUNTAR días? */
export function navegadorPospuesto(agenteId, ahora = Date.now()) {
  const t = Number(leer()[String(agenteId)])
  return t > 0 && ahora - t < DIAS_SIN_PREGUNTAR * 24 * 3600 * 1000
}

/** «Ahora no» (si = true) o quitarlo (al activarla, si = false). */
export function posponerEnNavegador(agenteId, si = true, ahora = Date.now()) {
  try {
    const m = leer()
    if (si) m[String(agenteId)] = ahora; else delete m[String(agenteId)]
    localStorage.setItem(CLAVE_POSPUESTA, JSON.stringify(m))
  } catch { /* sin almacenamiento */ }
}
